import { combineReducers } from "redux";
import authReducer from './Auth/reducer';
import inboundReducer from "./Inbound/reducer";
import myProfileReducer from "./Settings/myProfile/reducer"
import myBusinessReducer from "./Settings/myBusiness/reducer"
import contactsReducer from "./Contacts/reducer"
import stripeReducer from "./Stripe/reducer"
import quotaReducer from "./Quota/reducer"
import directoryReducer from "./Directory/reducer"
export default combineReducers({
    authReducer,
    inboundReducer,
    myProfileReducer,
    myBusinessReducer,
    contactsReducer,
    stripeReducer,
    quotaReducer,
    directoryReducer
});